import { Col, Image, Row } from 'antd';
import React from 'react';
import styled, { ITheme } from 'styled-components';
import ChainImg from 'src/assets/svg/Logo_Partners/Chain.png';
import EverseImg from 'src/assets/svg/Logo_Partners/Everse.png';
import ExnetworkImg from 'src/assets/svg/Logo_Partners/Exnetwork.png';
import GggImg from 'src/assets/svg/Logo_Partners/GGG.png';
import IbaImg from 'src/assets/svg/Logo_Partners/iba.png';
import InfinityGainzImg from 'src/assets/svg/Logo_Partners/infinity_gainz.png';
import KernelImg from 'src/assets/svg/Logo_Partners/Kernel.png';
import LotusImg from 'src/assets/svg/Logo_Partners/lotus.png';
import MavenImg from 'src/assets/svg/Logo_Partners/Maven.png';
import NewtribeImg from 'src/assets/svg/Logo_Partners/newtribe.png';
import ViaBtcImg from 'src/assets/svg/Logo_Partners/via_btc.png';
import ZbsImg from 'src/assets/svg/Logo_Partners/zbs.png';
import SeedThriftImg from 'src/assets/svg/Logo_Partners/SeedThrift.png';
import { ReactComponent as AvStarCapitalPartner } from '../../../assets/svg/Logo_Partners/AvStarCapitalPartner.svg';
import { ReactComponent as DutchPartner } from '../../../assets/svg/Logo_Partners/DutchPartner.svg';
import { ReactComponent as OigPartner } from '../../../assets/svg/Logo_Partners/OigPartner.svg';
import { ReactComponent as PandaCapitalPartner } from '../../../assets/svg/Logo_Partners/PandaCapitalPartner.svg';
import { ReactComponent as BasicsCapitalPartner } from '../../../assets/svg/Logo_Partners/BasicsCapitalPartner.svg';
import { ReactComponent as X21Partner } from '../../../assets/svg/Logo_Partners/X21Partner.svg';
import { ReactComponent as KangarooPartner } from '../../../assets/svg/Logo_Partners/KangarooPartner.svg';

export const Wrapper = styled.div`
    max-width: 1272px;
    margin: 0 auto;
    width: 100%;
    margin-top: 160px;
    .home-section {
        flex: 1;
        justify-content: center;
        margin-top: 60px;
    }
    .backers-fieldset {
        width: 100%;
        border: 0.5px solid ${({ theme }: { theme: ITheme }) => theme.green2};
        border-radius: 8px;
        .fieldset-title {
            width: 32%;
            color: ${({ theme }: { theme: ITheme }) => theme.white};
            margin-left: 100px;
            padding-left: 20px;
            .title-our {
                font-family: 'Orbitron';
                font-style: normal;
                font-weight: 700;
                font-size: 52px;
                line-height: 66px;
                letter-spacing: 0.02em;
                color: ${({ theme }: { theme: ITheme }) => theme.text3};
            }
            .title-backers {
                color: ${({ theme }: { theme: ITheme }) => theme.white};
            }
        }
    }
    .logo-backer {
        display: flex;
        justify-content: center;
        align-items: center;
        .partners-logo {
            width: 50%;
            margin: 0 auto;
        }
    }
    ${({ theme }: { theme: ITheme }) => theme.mediaWidth.upToMedium`
        max-width: 100%;
        padding: 0 30px;
        margin: 0 auto;
        width: 100%;
        margin-top: 80px;
        .home-section {
            flex: 1;
            justify-content: center;
        }
        .title-backers {
            font-size: 22px;
            line-height: 32px;
        }
        .backers-fieldset {
            width: 100%;
            border: none;
            border-radius: none;
            .fieldset-title {
                margin-left: 0;
                padding-left: 0;
                width: unset;
                text-align: center;
                .title-our {
                    font-size: 22px;
                    line-height: 32px;
                    letter-spacing: 0.02em;
                }
            }
        }
        .logo-backer {
            display: flex;
            justify-content: center;
            align-items: center;
            .partners-logo {
                width: 50%;
                margin: 0 auto;
            }
        }
    `}
`;

const listPartners = [
    {
        name: 'Lotus',
        logo: <Image className="partners-logo" preview={false} src={LotusImg} />,
    },
    {
        name: '3Basics Capital',
        logo: <BasicsCapitalPartner className="partners-logo" />,
    },
    {
        name: 'Everse',
        logo: <Image className="partners-logo" preview={false} src={EverseImg} />,
    },
    {
        name: 'Maven',
        logo: <Image className="partners-logo" preview={false} src={MavenImg} />,
    },
    {
        name: 'Exnetwork',
        logo: <Image className="partners-logo" preview={false} src={ExnetworkImg} />,
    },
    {
        name: 'X21',
        logo: <X21Partner className="partners-logo" />,
    },
    {
        name: 'Kernel',
        logo: <Image className="partners-logo" preview={false} src={KernelImg} />,
    },
    {
        name: 'ZBS',
        logo: <Image className="partners-logo" preview={false} src={ZbsImg} />,
    },
    {
        name: 'ViaBTC',
        logo: <Image className="partners-logo" preview={false} src={ViaBtcImg} />,
    },
    {
        name: 'IBA',
        logo: <Image className="partners-logo" preview={false} src={IbaImg} />,
    },
    {
        name: 'Chain',
        logo: <Image className="partners-logo" preview={false} src={ChainImg} />,
    },
    {
        name: 'Newtribe',
        logo: <Image className="partners-logo" preview={false} src={NewtribeImg} />,
    },
    {
        name: 'Kangaroo Capital',
        logo: <KangarooPartner className="partners-logo" />,
    },
    {
        name: 'GGG',
        logo: <Image className="partners-logo" preview={false} src={GggImg} />,
    },
    {
        name: 'Panda Capital',
        logo: <PandaCapitalPartner className="partners-logo" />,
    },
    {
        name: 'Infinity',
        logo: <Image className="partners-logo" preview={false} src={InfinityGainzImg} />,
    },
    {
        name: 'AV Star Capital',
        logo: <AvStarCapitalPartner className="partners-logo" />,
    },
    {
        name: 'OIG',
        logo: <OigPartner className="partners-logo" />,
    },
    {
        name: 'Dutch Crypto INVESTORS',
        logo: <DutchPartner className="partners-logo" />,
    },
    {
        name: 'Seed Thrift',
        logo: <Image className="partners-logo" preview={false} src={SeedThriftImg} />,
    },
];

export default function BackersV2() {
    return (
        <Wrapper data-aos="fade-down" data-aos-offset="100" data-aos-easing="ease-in-sine" data-aos-duration="500">
            <fieldset className="backers-fieldset">
                <legend className="fieldset-title">
                    <span className="title-our">Our</span> <span className="title-backers title-our">Backers</span>
                </legend>
                <Row className="home-section">
                    {listPartners.map((partner, idx) => {
                        const key = idx + 1;
                        return (
                            <Col key={key} lg={4} xs={8} className="logo-backer">
                                {partner.logo}
                            </Col>
                        );
                    })}
                </Row>
            </fieldset>
        </Wrapper>
    );
}
